<template>
    <div class="content-container news-post-preview">
        <div class="header">
            <div class="title"><router-link :to="{path: '/topics/' + this.topic.topicID}">{{ topic.title | decodeHtml }}</router-link></div>
            <div class="view-post-action"><router-link :to="{path: '/topics/' + this.topic.topicID}">View Topic</router-link></div>
        </div>        
        <div class="content nopad">
            <div class="pli-layout-body">
                <div class="pli-layout-authorinfo">
                    <div class="pli-content-authorinfo">
                        <ul>
                            <li class="avatar"><img class="avatar-img" :src="avatarSource" alt=""></li>
                            <li>Posted By</li>
                            <li><router-link :to="{path: '/members/' + topic.memberID}">{{ topic.memberDisplayName }}</router-link></li>
                            <li>{{ topic.dateStartedUTC | localDate }}</li>
                            <li>{{ topic.replyCount }} replies</li>
                        </ul>
                    </div>
                </div>
                <div class="pli-layout-content-container">
                    <div class="pli-layout-postcontent">
                        <div class="pli-content-postcontent">
                            <div v-html=topic.excerpt></div>
                        </div>
                    </div>
                </div>

            </div>
        </div>        
    </div>
</template>

<script>
    export default {
        props: ['topic'],
        computed: {
            avatarSource() {
                if (this.topic.memberAvatarUrl === null) {
                    return '/icons/avatar.png'
                } else {
                    return this.topic.memberAvatarUrl;
                }
            }
        }
    }
</script>
